import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children } from 'react';
import { TAB_CLASS_PREFIX } from '../../Tab/constants';
import { getElementName } from '../../../utils';

var isValidTabComponent = function isValidTabComponent(element) {
  return getElementName(element) === TAB_CLASS_PREFIX;
};

var preProcessTabChildren = function preProcessTabChildren(children, additionalProps) {
  return Children.map(children, function (child, tabIndex) {
    if (!isValidTabComponent(child)) {
      return null;
    }

    return child ? React.cloneElement(child, _objectSpread(_objectSpread({}, additionalProps), {}, {
      tabIndex: tabIndex
    })) : null;
  });
};

export default preProcessTabChildren;